import React, { useMemo } from 'react';
import ModalForm from '../../../Components/ModalForm/ModalForm';
import { ReferenceInput, required, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import SelectInputCustom from '../../../Components/InputsCustom/SelectInputCustom';
import { TextInputCustom } from '../../../Components/InputsCustom/TextInputCustom/TextInputCustom';
import AutocompleteInputCustom from '../../../Components/InputsCustom/AutocompleteInputCustom/AutocompleteInputCustom';
import { useSelector } from 'react-redux';
import { useWatch } from 'react-hook-form';

const UserFields = ({ isEdit, permissions, translate, merchantsForm }) => {
  const record = useRecordContext();
  const roleSelected = useWatch({ name: 'role', defaultValue: record?.role ?? null });
  const merchantSelected = useWatch({ name: 'merchant_id', defaultValue: null });

  const choices = permissions == 'admin' ? [
    { id: 'admin', name: 'Admin' },
    { id: 'manager', name: 'Manager' },
    { id: 'cashier', name: 'Cajero' },
  ] : [{ id: 'cashier', name: 'Cajero' }];

  return (
    <>
      <TextInputCustom size='small' source="name" label={translate('resources.users.fields.name', { _: 'name' })} fullWidth validate={[required()]} />
      <TextInputCustom size='small' source="email" label={translate('resources.users.fields.email', { _: 'Email' })} fullWidth validate={[required()]} />
      <SelectInputCustom
        source={'role'}
        choices={choices}
        disabled={isEdit && permissions !== 'admin'}
        validate={[required()]}
      />

      {
        (permissions == 'admin' && merchantsForm.length > 0 && (roleSelected === 'cashier' || roleSelected === 'manager')) && (
          <AutocompleteInputCustom
            optionValue={'name'}
            optionText={'name'}
            source={'merchant_id'}
            label={'merchant'}
            variant='outlined'
            choices={merchantsForm}
            validate={[required()]}
          />
        )
      }

      {
        (roleSelected === 'cashier' || (isEdit && roleSelected === null)) && (
          <ReferenceInput
            source="branch_id"
            perPage={999}
            reference="branches"
            filter={permissions === 'admin' ? { merchant: merchantSelected } : {}}
          >
            <AutocompleteInputCustom
              validate={[required()]}
              source={'branch_id'}
              label={'branch'}
              optionText={'name'}
              variant='outlined'
            />
          </ReferenceInput>
        )
      }
    </>
  );
};

const FormUser = ({ title, isEdit }) => {
  const { merchants } = useSelector(state => state.merchant);

  const { permissions } = usePermissions();
  const translate = useTranslate();

  const merchantsForm = useMemo(
    () => merchants?.map(m => ({ value: m, name: m })) || [],
    [merchants]
  );

  return (
    <ModalForm title={translate(title)} source='/users'>
      <UserFields
        isEdit={isEdit}
        permissions={permissions}
        translate={translate}
        merchantsForm={merchantsForm}
      />
    </ModalForm>
  );
};

export default FormUser;
